import { NycbsPharmaOrderModel } from "../../../data-model/nycbsPharmaOrder";
import { NycbsPharmaOrderKeys } from "../../../enums/nycbsPharmaOrder";
import { generateFieldNamesWhichHaveNoValue } from "../../cmmOrder/table/cmmOrderTableData";
import { getButtonConfig } from "../../cmmOrder/utils/getButtonLabel";

/**
 * Inputs used to derive the pharma PA form footer CTA state.
 */
interface FooterButtonConfigParams {
  data: NycbsPharmaOrderModel | null;
  isAllFieldsValidationFree: boolean;
  isFormDirty: boolean;
}

/**
 * Builds the footer CTA label, action id, and disabled state for the PA form.
 *
 * @param params - Order data plus form validation/dirty flags
 * @returns Footer button label, buttonId, and disabled flag
 */
export const getFooterButtonConfig = ({
  data,
  isAllFieldsValidationFree,
  isFormDirty,
}: FooterButtonConfigParams) => {
  if (!data) {
    return {
      label: "Send to Plan",
      buttonId: "send_to_plan",
      disabled: true,
    };
  }

  const noDataFields = generateFieldNamesWhichHaveNoValue(data);
  const hasMissingData = noDataFields.length > 0;
  const buttonConfig = getButtonConfig(
    data?.[NycbsPharmaOrderKeys.CmmStatus] ?? "",
    hasMissingData,
  );

  // Additional checks for form-specific conditions
  let isDisabled = buttonConfig.disabled;

  // If button is for "Send to Plan", apply additional validation checks
  if (buttonConfig.buttonId === "send_to_plan") {
    if (
      data?.[NycbsPharmaOrderKeys.CmmResultKey] === undefined ||
      data?.[NycbsPharmaOrderKeys.CmmResultKey] === null ||
      data?.[NycbsPharmaOrderKeys.CmmResultKey]?.trim() === ""
    ) {
      isDisabled = true;
    }

    if (!isAllFieldsValidationFree) {
      isDisabled = true;
    }

    if (isFormDirty) {
      isDisabled = true;
    }
  }

  return {
    label: buttonConfig.label,
    buttonId: buttonConfig.buttonId,
    disabled: isDisabled,
  };
};
